import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { AgreementLink } from "@src/appV2/WorkplaceAgreement/AgreementLink";
import {
  AGREE_AND_ACCEPT_LABEL,
  WorkplaceAgreementDialogShell,
} from "@src/appV2/WorkplaceAgreement/WorkplaceAgreementDialogShell";

// The per-user gate links the Clipboard Works legal documents, which live on a different domain
// from the `ContactCBHInfo` Terms of Service URL used by the "on" variation. Keep them distinct.
const TERMS_OF_SERVICE_URL = "https://www.clipboardworks.com/terms-of-service";
const PRIVACY_POLICY_URL = "https://www.clipboardworks.com/privacy-policy";

export interface WorkplaceAgreementPerUserDialogViewProps {
  isOpen: boolean;
  isSubmitting: boolean;
  onAgree: () => void;
}

/**
 * "per-user" variation: each workplace user accepts the Terms of Service and Privacy Policy
 * personally. There is no legal entity name to capture, so acceptance is always available.
 */
export function WorkplaceAgreementPerUserDialogView(
  props: WorkplaceAgreementPerUserDialogViewProps
) {
  const { isOpen, isSubmitting, onAgree } = props;

  return (
    <WorkplaceAgreementDialogShell
      isOpen={isOpen}
      title="Terms of Service & Privacy Policy"
      isSubmitting={isSubmitting}
      onAgree={onAgree}
    >
      <Stack spacing={5}>
        <Text variant="body2" sx={{ color: "base.muted" }}>
          Please carefully review the documents below. By clicking &apos;{AGREE_AND_ACCEPT_LABEL}
          &apos;, you confirm that you have read, understood, and agree to be bound by
          Clipboard&apos;s Terms of Service, and acknowledge that you have read our Privacy Policy.
        </Text>

        <Stack spacing={3}>
          <AgreementLink to={TERMS_OF_SERVICE_URL}>Terms of Service</AgreementLink>
          <AgreementLink to={PRIVACY_POLICY_URL}>Privacy Policy</AgreementLink>
        </Stack>
      </Stack>
    </WorkplaceAgreementDialogShell>
  );
}
